<template>
    <div>
        <div class="page-top mb-1 mb-3 align-center clearfix">
            <h1 class="float-left"> Fee Vouchers </h1>
            <a   v-on:click="bulkUpload" class="btn btn-primary float-right active"> Bulk Upload Voucher </a>
            <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" name="" />
            </div>
        </div>
        <table id="feeVoucher" class="table">
            <thead>
            <tr>
                <th style="display: none;"></th>
                <th>Student ID</th>
                <th>Invoice Number</th>
                <!-- <th>Unique Identifier</th> -->
                <th>Challan No.</th>
                <th>Invoice Amount</th>
                <th>Invoice Due Date</th>
                <th>Status</th>
                <th>Action</th>
            </tr>
            </thead>
        </table>
    </div>
</template>

<script>
    var gThat = null;
    export default {
        data() {
            return {
                data : null,
                feeType : 'voucher'
            };
        },
        mounted() {
            gThat = this;
            gThat.$Progress.start();
            var feeVoucher = $('#feeVoucher').DataTable({
                "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                processing: true,
                serverSide: true,
                ajax: {
                    "url": "api/listFeeVouchers",
                    "headers": window.axios.defaults.headers.common,
                    "dataSrc": "records",
                },
                deferRender: true,
                columns: [
                    {data: 'id', visible: false},
                    {data: 'student.student_id'},
                    {data: 'invoice_no'},
                    {data: 'unique_identifier'},
                    {data: 'invoice_amount'},
                    {data: 'invoice_due_date'},
                    {data: 'status',render:function(data,type,full){
                        var value = '';
                        switch(full['status']){
                            case 'UNPAID': value = 'Un-Paid';break;
                            case 'PARTIALLY_PAID': value = 'Partially Paid';break;
                            case 'PAID': value = 'Paid';break;
                        }
                        return value;
                    }},
                    {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/feeVoucherDetail/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a><a href="javascript:void(0);" onclick="VueComponents.feeVouchersComponent.methods.downloadVoucher(' + full['id'] + ');" class="action edit"><i class="fas fa-download"></i></a>';
                    }},
                ],
                "order": [[ 0, "desc" ]],
                "initComplete": (settings, json) => {
                    gThat.feeType = json.company_fee_type;
                    gThat.$Progress.finish();
                }
            });
            $('#customSearch').on( 'keyup', function () {
                feeVoucher.search(this.value).draw();
            });
        },
        created() {
            //
        },
        methods :{
            bulkUpload : function() {
                var url = '/feeBulkUploadVouchers/'+this.feeType;
                 this.$router.push({ path: url })
                },
            downloadVoucher: function(id){

                gThat.$Progress.start();
                toast.fire({ type: 'success', title: 'Processing ...'});

                axios.get('/api/feeVoucherDownload/' + id, {responseType: 'arraybuffer'})
                .then((response) => {
                    if(response.status == 200)
                    {
                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Fee-Voucher-' + moment().format('YYYYMMDDHHmmss') + '-' + id + '.pdf';
                        link.click();
                        toast.fire({
                            type: 'success',
                            title: 'File Downloaded Successfully'
                        });

                        gThat.$Progress.finish();
                    }
                    else
                    {
                        gThat.showAlertBox('error','There is some problem');
                    }
                }).catch((err) => {
                    gThat.showAlertBox('error','There is some problem');
                });
            }
        }
    }
</script>
